import { createFileRoute } from "@tanstack/react-router";
import Customers from "@/pages/Customers";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/customers")({
  head: () => pageHead("/customers", "en"),
  component: Customers,
});
